var $nav, UP = 'up', DOWN = 'down', mobilePoint = true;

$(function() {
	
	$(window).setBreakpoints({
	    distinct: true, 
	    breakpoints: [
	        767
	    ] 
	});
	
	/* ELEMENTS */
	if ( typeof $.fancybox == 'function') {
		$(".fancybox").fancybox({
			openEffect : 'elastic',
			closeEffect : 'none',
			nextEffect: 'none',
			prevEffect: 'none',
			loop : false,
			padding : 0,
			helpers : {
		        overlay : {
		            locked : false
		        }
		    },
			afterShow: function() {
                if ('ontouchstart' in document.documentElement){
                    $('.fancybox-nav').css('display','none');
                    $('.fancybox-wrap').swipe({
                        swipe : function(event, direction) {
                            if (direction === 'left' || direction === 'up') {
		                        $.fancybox.next();
                            } else {
                            	$.fancybox.prev();
                            }
                        }
                    });
                }
            }
		});
	}
	
	if(Modernizr.touch) {
		$('.cycle-slideshow').each(function(index){
			$(this)
				.swipe({
	                swipe : function(event, direction) {
	                    if (direction === 'left' || direction === 'up') {
	                        $(this).cycle('next');
	                    } else {
	                        $(this).cycle('prev');
	                    }
	                }, allowPageScroll:"vertical"
	            });
		});
	}
	
	// clickable element
    $('.link').click(function(e){
		if($(e.target).is('a')) {
		    return; 
		} else if ($(e.target).parent('a').length) {	    
		    e.preventDefault();
		    if($(e.target).parent('a').hasClass('fancybox')){
				$(e.target).parent('a').click();
		    } else {
				window.location = $(e.target).parent('a').attr('href');
		    }	    
		    return false;
		} else if($(this).find('a.target').length) {
		    e.preventDefault();	    
		    if($(this).find('a.target').hasClass('fancybox')){		
				$(this).find('a.target').click();
		    } else {	
				window.location = $(this).find('a.target').attr('href');
		    }
		    return false;
		} else if($(this).find('input[type="submit"]').length) {
		    $(this).find('form').submit();
		}
    });	
	
	/* SEARCH */
	$('#search-submit').click(function(event){
		var $form = $('#search-form');
		if(! $form.hasClass('open')){
			event.preventDefault();
			
			$form.addClass('open');
			$('#search-field').focus();
		} else if($('#search-field').val() == ''){
			event.preventDefault();
			
			$form.removeClass('open');
		}
	});
	
	/* NAVIGATION */
	$nav = $('.main-nav');
	$nav
		.prepend('<i class="icon-hamburger"></i>')
		.click(function(e) {
			var $target = $(e.target);
			if(mobilePoint && ($target.is('a') === false || $target.parent().hasClass('active'))) {
				e.preventDefault();
				$nav.toggleClass('open');
			}		
		});
		
	if(!$('.main-nav li.active').length){
		$nav.find('.nav-wrap.nav--left').prepend('<li class="active placeholder"><a href="#">menu</a></li>')
	}
	
	/* Carousel */
	$('.carousel-detail').cycle();
	
	$('.carousel-detail,.product-slider').swipe({
		excludedElements: 'button, input, select, textarea, .noSwipe',
		swipeLeft: function(event, direction, distance, duration, fingerCount){
			$(this).cycle('next');
		},
		swipeRight: function(event, direction, distance, duration, fingerCount){
			$(this).cycle('prev');
		}
	});	

	init_cycle();
	
	$( '.product-slider' ).on( 'cycle-after', function( event, opts ) {
		var index = opts.slideNum + 1,
			$image = $('.product-slider .cycle-carousel-wrap img:eq('+index+')');
			
		if($image.attr('src') != $image.attr('data-src')){
			$image.attr('src', $image.attr('data-src'));
		}			
	});

    function init_cycle() {
        var width = $(window).width(); // Checking size again after window resize
        if ( width <= 768 ) {
            $('.product-slider').cycle('destroy');
            initCycle(1,0,500);
        } else {
            $('.product-slider').cycle('destroy');
            initCycle(3,1,500);
        }
		
		var sliderMinWidth = width / 3;
		
		$('.product-slider > .cycle-carousel-wrap > a').css('min-width', sliderMinWidth);
    }
    function initCycle(visibleSlides, startingSlide, speed) {
        $('.product-slider').cycle({
            fx: 'carousel',
            slides: '> a',
            next: '#carousel-right',
            prev: '#carousel-left',
			paused: true,
			allowWrap: false,
			startingSlide: startingSlide,
            carouselVisible: visibleSlides,
			carouselFluid: true,
			random: false,
			manualSpeed: speed,
			captionTemplate: '{{cycleTitle}}',
			caption: '#product-slider-caption span'
        });
    }
    var reinitTimer;
    $(window).resize(function() {
        clearTimeout(reinitTimer);
        reinitTimer = setTimeout(init_cycle, 100); // Timeout limits the number of calculations   
    });
	
	
	if ($('.product-slider').length) {
		$(document.documentElement).keyup(function(event) {
			if (event.keyCode == 37) {
				$('.product-slider').cycle('prev');
			} else if (event.keyCode == 39) {
				$('.product-slider').cycle('next')
			}
		});
	}
		
	$( '.product-slider .cycle-slide' ).click(function(event){
		event.preventDefault();
		var index = $('.product-slider').data('cycle.API').getSlideIndex(this);
		$('.product-slider').cycle('goto', index);
    });

	//fancybox
	if(typeof $.fancybox == 'function') {
		$('.fancybox').fancybox({
			openEffect : 'elastic',
			closeEffect : 'none',
			loop : false,
			helpers : {
				overlay : {
					locked : false
				}
			},
			afterShow: function() {
				if ('ontouchstart' in document.documentElement){
					$('.fancybox-nav').css('display','none');
					$('.fancybox-wrap').swipe({
						swipe : function(event, direction) {
							if (direction === 'left' || direction === 'up') {
								$.fancybox.next();
							} else {
								$.fancybox.prev();
							}
						}
					});
				}
			},
			tpl : {
				closeBtn : '<a title="Sluiten" class="fancybox-item fancybox-close" href="javascript:;"></a>',
				error:'<p class="fancybox-error">De gevraagde inhoud kan niet worden.<br/>Probeer later opnieuw.</p>',
				next:'<a title="Volgende" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
				prev:'<a title="Vorige" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>'
			}
		});
	}


	// grab an element
	var myElement = document.querySelector(".fixed--header");
	// construct an instance of Headroom, passing the element
	var headroom  = new Headroom(myElement);
	// initialise
	headroom.init({
		// vertical offset in px before element is first unpinned
		offset : 500,

	});



	// ZOOM

	$('.zoom-image').ezPlus({
		zoomType: 'lens',
		lensShape: 'round',
		lensSize: 200
	});


	//Images articles

	
});

$(window).bind('enterBreakpoint767',function() {
	mobilePoint = false;
	
});

$(window).bind('exitBreakpoint767',function() {
	mobilePoint = true;
});